import React, {Component} from "react";
import { Menu} from 'antd';
import {Icon} from "@ant-design/compatible"
const SubMenu = Menu.SubMenu;

class ContextMenu extends Component {

  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    if (this.props.visible) {
      console.debug(`ContextMenu: this.props.output => ${this.props.output}`);

      return (
        <Menu onClick={this.handleClick}
              style={{width: 256}}
              mode="vertical"
              // theme="dark"
              selectable={false}>
          <SubMenu key="delete" disabled={this.props.id === ""} onTitleClick={this.handleClick}
                   title={<span><Icon type="delete"/><span>删除</span></span>}/>
          <SubMenu key="copy" disabled={this.props.id === ""} onTitleClick={this.handleClick}
                   title={<span><Icon type="copy"/><span>拷贝</span></span>}/>
          <SubMenu key="cut" disabled={this.props.id === ""} onTitleClick={this.handleClick}
                   title={<span><Icon type="file-text"/><span>剪切</span></span>}/>
          <SubMenu key="paste" disabled={this.props.clone === null} onTitleClick={this.handleClick}
                   title={<span><Icon type="pushpin"/><span>粘贴</span></span>}/>
          {this.renderDynamic()}
          {/*TODO: add run menu*/}
          <SubMenu key="run" disabled={this.props.id === "" || this.props.item === undefined} onTitleClick={this.handleClick}
                   title={<span><Icon type="cloud"/><span>运行</span></span>}/>
        </Menu>
      )
    } else {
      return null;
    }
  }

  renderDynamic() {
    if (this.props.output) {
      return this.props.output.map((o, index) => {
        return (
          <SubMenu key={`${index}`} disabled={
            this.props.id === "" || (this.props.item === undefined ||
              this.props.item === null ||
              this.props.item.algorithmStatus === undefined ||
              this.props.item.algorithmStatus === null ||
              this.props.item.algorithmStatus === ""
            )}
                   title={<span><Icon type="appstore"/><span>{`评估结果${o.name}`}</span></span>}>
            <Menu.Item key="view">查看</Menu.Item>
            <Menu.Item key="save">保存</Menu.Item>
          </SubMenu>
        )
      })
    }
    return null;
  }

  handleClick(e) {
    switch (e.key) {
      case "delete":
        this.props.delete(this.props.id);
        break;
      case "copy":
        this.props.copy(this.props.id);
        break;
      case "cut":
        this.props.cut(this.props.id);
        break;
      case "paste":
        this.props.paste(this.props.id);
        break;
      case "view":
        break;
      case "save":
        this.props.save(this.props.id, e.keyPath[1]);
        break;
      case "run":
        this.props.run(this.props.id);
        break;
      default:
        break;
    }
  }
}

export default ContextMenu;
